var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgNew = function SvgNew(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16,0A16,16,0,1,0,32,16,16,16,0,0,0,16,0ZM11.88,19.53H10.47l-3-4.12v4.12H6V12.47H7.47l2.94,4.12V12.47h1.47ZM17.76,14H14.82v1.32h2.94v1.48H14.82v1.31h2.94v1.47h-4.7V12.47h4.7ZM26,18.35a1.18,1.18,0,0,1-1.18,1.18h-4.7a1.18,1.18,0,0,1-1.18-1.18V12.47h1.47v5.31h1.33V13.64h1.47v4.12h1.32V12.47H26Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgNew);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "new.6cb1cc65dd873cfbab3c7e0429384053.svg";